import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api, money } from "@/lib/api";

// Bandeau : écart de plus de 50 $ entre le net TPS/TVQ et les paiements à Revenu Québec (trimestre terminé, avant sa date limite)
export const AlerteEcartTaxes = () => {
  const [alertes, setAlertes] = useState([]);
  useEffect(() => { api.get("/conciliation-taxes/alertes").then((r) => setAlertes(r.data)).catch(() => {}); }, []);
  if (!alertes.length) return null;
  return (
    <div className="mb-6 flex flex-wrap items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3" data-testid="alerte-ecart-taxes">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
      <div className="flex-1 min-w-0 text-sm text-amber-900">
        <p className="font-medium">Écart TPS/TVQ avec Revenu Québec</p>
        {alertes.map((a) => (
          <p key={a.periode} data-testid={`alerte-ecart-${a.periode}`}>
            {a.libelle} : {money(Math.abs(a.ecart))} {a.ecart > 0 ? "payé en trop" : "reste à payer"}{a.limite ? ` · date limite ${a.limite}` : ""}
            {a.reste_a_payer !== undefined && <span className="block text-xs" data-testid={`alerte-ecart-${a.periode}-detail`}>Dû {money(a.du)} − acomptes et versements {money(a.verse)} = reste à payer {money(a.reste_a_payer)} ; solde payé {money(a.solde_paye)}</span>}
          </p>
        ))}
      </div>
      <Link to="/commentaires" className="text-sm font-medium text-emerald-700 hover:underline" data-testid="alerte-ecart-voir">Voir la conciliation</Link>
    </div>
  );
};
